import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSupplierForm from "../../forms/CreateOrUpdateSupplierForm";

interface CreateSupplierModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateSupplierModal: React.FC<CreateSupplierModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Add New Supplier"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateSupplierForm loading={loading} error={error} />
  </AppModal>
);

export default CreateSupplierModal;
